export { PlainTextResponseSectionTypename, SourcesListResponseSectionTypename } from '../__generated__/chirp/com/hubspot/copilot/rpc/v2/CopilotMessageService';

// BreezeEngineModels/BreezeArtifactType.java string keys
export const BZE_ARTIFACT_TYPE_MARKDOWN = 'MARKDOWN';
export const BZE_ARTIFACT_TYPE_HTML = 'HTML';
export const BZE_ARTIFACT_TYPE_CODE = 'CODE';
export const BZE_ARTIFACT_TYPE_CSV = 'CSV';
export const BZE_ARTIFACT_TYPE_TEXT = 'TEXT';
export const BZE_ARTIFACT_TYPE_EMAIL = 'EMAIL';
export const BZE_ARTIFACT_TYPE_LANDING_PAGE = 'LANDING_PAGE';
export const BZE_ARTIFACT_TYPE_BLOG_POST = 'BLOG_POST';
export const BZE_ARTIFACT_TYPE_SITE_PAGE = 'SITE_PAGE';
export const BZE_ARTIFACT_TYPE_FORMS_CONDITIONAL_LOGIC = 'FORMS_CONDITIONAL_LOGIC';
export const BZE_ARTIFACT_TYPE_REPORT = 'REPORT';
export const BZE_ARTIFACT_TYPE_DATA_MODEL = 'DATA_MODEL';
export const BZE_ARTIFACT_STATUS_ACTIVE = 0;
export const BZE_ARTIFACT_STATUS_ARCHIVED = 1;
export const BZE_ARTIFACT_STATUS_COMPLETED = 2;